import { RmaIcons } from '@rma/generic/ui/icon';
import { SyndicationChannel } from './syndication-channels.model';

interface SyndicationChannelConfigItem {
  icon: RmaIcons;
  baseIcon: RmaIcons;
  name: string;
}

export function getChannelConfigProperty(obj: SyndicationChannelConfigItem, key: keyof SyndicationChannelConfigItem) {
  return obj[key];
}

export const SYNDICATION_CHANNELS_CONFIG: Record<SyndicationChannel, SyndicationChannelConfigItem> = {
  google: {
    icon: 'social-google-colour',
    baseIcon: 'social-google',
    name: 'syndicationChannels.google',
  },
  domain: {
    icon: 'platform-domain',
    baseIcon: 'platform-domain',
    name: 'syndicationChannels.domain',
  },
  realtor: {
    icon: 'platform-realtor',
    baseIcon: 'platform-realtor-base',
    name: 'syndicationChannels.realtor',
  },
  generic: {
    icon: 'rma-smm',
    baseIcon: 'rma-smm',
    name: 'syndicationChannels.generic',
  },
  instagram: {
    icon: 'social-instagram-colour',
    baseIcon: 'social-instagram',
    name: 'syndicationChannels.instagram',
  },
  facebook: {
    icon: 'social-facebook-colour',
    baseIcon: 'social-facebook',
    name: 'syndicationChannels.facebook',
  },
  twitter: {
    icon: 'social-twitter-colour',
    baseIcon: 'social-twitter',
    name: 'syndicationChannels.twitter',
  },
  linkedIn: {
    icon: 'social-linkedin-colour',
    baseIcon: 'social-linkedin',
    name: 'syndicationChannels.linkedIn',
  },
  widget: {
    icon: 'public',
    baseIcon: 'public',
    name: 'syndicationChannels.widgets',
  },
  reiwa: {
    icon: 'platform-reiwa',
    baseIcon: 'platform-reiwa-base',
    name: 'syndicationChannels.reiwa',
  },
  soho: {
    icon: 'platform-soho',
    baseIcon: 'platform-soho-base',
    name: 'syndicationChannels.soho',
  },
  onTheHouse: {
    icon: 'platform-onTheHouse',
    baseIcon: 'platform-onTheHouse-base',
    name: 'syndicationChannels.onTheHouse',
  },
  allHomes: {
    icon: 'platform-allHomes',
    baseIcon: 'platform-allHomes-base',
    name: 'syndicationChannels.allHomes',
  },
  rma: {
    icon: 'rma-brand-flag',
    baseIcon: 'rma-brand-flag-base',
    name: 'syndicationChannels.rma',
  },
  zillow: {
    icon: 'platform-zillow',
    baseIcon: 'platform-zillow-base',
    name: 'syndicationChannels.zillow',
  },
  yelp: {
    icon: 'platform-yelp',
    baseIcon: 'platform-yelp-base',
    name: 'syndicationChannels.yelp',
  },
} as const;
